import { useQuery } from "react-query";
import { downloadFile } from "../../api/generic-api";
import { WorkOrderDocument } from "../../models";

export const useDownloadWorkOrderDocument = (
  workOrderDocument?: WorkOrderDocument,
  download: boolean = false
) => {
  return useQuery<any, Error>(
    [],
    async () =>
      downloadFile(
        `documents/work-order-document/download/${workOrderDocument?.id}`,
        workOrderDocument?.name ?? "file"
      ),
    {
      enabled: Boolean(download && workOrderDocument),
    }
  );
};
